
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.555","cy":"8.015","r":"7.413","stroke":"#AAB4C0","stroke-width":"1.202"}}),_c('path',{attrs:{"d":"M7.95 11.826h.001l4.21-6.628h0v-.001a.712.712 0 00.13-.382.502.502 0 00-.142-.366.513.513 0 00-.367-.14.51.51 0 00-.267.064.607.607 0 00-.2.21h-.001l-3.923 6.252-1.987-2.601a.654.654 0 00-.202-.195.51.51 0 00-.262-.064.507.507 0 00-.527.519c0 .13.055.267.15.387 0 0 0 0 0 0l2.312 2.944h0c.074.093.15.168.24.22.091.052.19.076.302.076a.61.61 0 00.534-.295z","fill":"#AAB4C0","stroke":"#AAB4C0","stroke-width":".2"}})])
          )
        }
      }
    